import React from "react";

import {

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  IconButton,

  Typography,

  Box,

} from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";

const ConfirmDialog = ({

  open,

  onClose,

  onConfirm,

  title = "Confirm Save Changes",

}) => {

  return (
    <Dialog

      open={open}

      onClose={onClose}

      maxWidth="xs"

      fullWidth

      sx={{

        "& .MuiPaper-root": {

          borderRadius: "12px",

        },

      }}
    >

      {/* Header */}
      <DialogTitle

        sx={{

          display: "flex",

          justifyContent: "space-between",

          alignItems: "center",

          borderBottom: "1px solid #E7E8E9",

          padding: "10px 24px",

        }}
      >
        <Typography variant="h6">

          Confirmation
        </Typography>

        <IconButton

          edge="end"

          color="inherit"

          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Box

          sx={{

            textAlign: "center",

            py: 2,

          }}
        >
          <Typography

            sx={{

              fontSize: "16px",

              fontWeight: 500,

              color: "#374151",

              mb: 2,

            }}
          >

            {title}
          </Typography>

          <Typography

            sx={{

              fontSize: "14px",

              color: "#6b7280",

              lineHeight: 1.5,

            }}
          >

            Are you sure you want to save these configuration

            changes?
          </Typography>
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions

        sx={{

          padding: "1rem",

          borderTop: "1px solid #E7E8E9",

          justifyContent: "center",

          gap: 1,

        }}
      >
        <button

          className="btn btn-secondary"

          onClick={onClose}
        >

          Cancel
        </button>

        <button

          className="btn"

          onClick={onConfirm}
        >

          Save
        </button>
      </DialogActions>
    </Dialog>

  );

};

export default ConfirmDialog;
